import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import store from "../../store";
import { createToaster } from "@meforma/vue-toaster";

let connection;
let toaster = createToaster({
  position: "top-right",
  duration: 10000,
});

export async function setupConnection() {
  let baseUrl = store.getters.get_api_url;
  let accessToken = store.getters.currentUserInfo.token;

  if (accessToken != null & accessToken != "") {
    connection = new HubConnectionBuilder()
      .withUrl(baseUrl + 'notificationHub', {
        accessTokenFactory: () => accessToken,
        withCredentials: false,
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    connection.on('ReceiveTicketNotification', (notification) => {
      let createUserFullName = notification.createUser?.firstName + ' ' + notification.createUser?.lastName;
      let message = notification.message?.length > 0 ? notification.message : 'تیکتی به شما ارجاع داد';
        
      store.dispatch('addListNewNotifications', [notification]);

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
          registration.active?.postMessage({
            type: 'notify',
            payload: {
              title: createUserFullName,
              body: message,
              tag: notification.id
            }
          });
        });
      }

      toaster.info(
        `${createUserFullName}
         ${message}`
      );
    });
    
    connection.on('RemoveLastReferTicketNotifications', (ticketId) => {
      store.dispatch('removefromMyTicketsNotifications', [ticketId]);
      store.dispatch('removefromReferredTicketsNotifications', [ticketId]);
    });

    await connection.start();
  }
  // else {
  //   console.log("Connection to NotificationHub is not stablished.");
  // }
}

export async function stopConnection() {
  if (connection) {
    await connection.stop();
  }
  // else {
  //   console.log("Connection to NotificationHub is not defined.");
  // }
}
